import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thread-messages',
  templateUrl: './thread-messages.component.html',
  styleUrls: ['./thread-messages.component.css']
})
export class ThreadMessagesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/chat/sub-components/thread-messages/thread-messages.component.ts